import { Button } from '@/shared/ui/button';

type CodexOffProps = { isStarting: boolean; onConnect: () => void };

export function CodexOff({ isStarting, onConnect }: CodexOffProps) {
  return (
    <>
      <p className="text-muted">
        Point your Agents API webhook at Macswarm. Codex then picks Macswarm as its sandbox.
      </p>
      <Button variant="primary" className="self-start" isLoading={isStarting} onClick={onConnect}>
        Connect Codex
      </Button>
    </>
  );
}
